export const SF_CONTENT_VERSION_TYPES = {
  EXECUTIVE_SUMMARY: 'Executive summary'
}

export const contentVersionFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Type__c: 'type',
  CreatedById: 'createdBy',
  ContentDocumentId: 'contentDocument',
  Title: 'title',
  Description: 'description',
  PathOnClient: 'pathOnClient',
  NetworkId: 'networkId',
  TagCsv: 'tagCsv',
  VersionData: 'versionData',
  FirstPublishLocationId: 'firstPublishLocationId'
}

export interface ContentVersion {
  id: string
  type: string
  createdBy: string
  contentDocument: string
  title: string
  description: string
  pathOnClient: string
  networkId: string
  tagCsv: string
  versionData: string
  firstPublishLocationId: string
}
